import { Text } from '@sendoutcards/quantum-design-ui'
import React from 'react'
import styles from './actField.module.scss'

type ActFieldProps = {
  icon?: string
  placeHolder?: string
  onClick?: () => void
  filledInfo?: React.ReactNode
  leftPlaceholder?: React.ReactNode
  rigthElement?: React.ReactNode
}

const ActField: React.FC<ActFieldProps> = props => {
  const { onClick, filledInfo, placeHolder, rigthElement, leftPlaceholder } =
    props

  return (
    <div
      className={styles.wrapper}
      onClick={onClick}
      style={!!onClick ? { cursor: 'pointer' } : undefined}
    >
      <div
        className={styles.leftElement}
        style={!!filledInfo ? { borderColor: 'transparent' } : undefined}
      >
        {filledInfo ? (
          filledInfo
        ) : (
          <>
            {leftPlaceholder}
            <div className={styles.placeHolder}>
              <Text type="body" content={placeHolder} />
            </div>
          </>
        )}
      </div>
      {rigthElement ? (
        <div className={styles.rightElement}>{rigthElement}</div>
      ) : (
        <></>
      )}
    </div>
  )
}

export default ActField
